import axios from "axios";
import { QUANTUM_API } from "../utils/constant";
import { toastr } from "react-redux-toastr";
import {
  QUANTUM_OVERVIEW_FETCHED,
  QUANTUM_DETAILS_FETCHED,
  QUANTUM_GRAPH_DATA_FETCHED,
  QUANTUM_DOWNLOAD_START,
  QUANTUM_DOWNLOAD_SUCCESS,
  QUANTUM_DOWNLOAD_ERROR,
  QUANTUM_TOKEN_GENERATING,
  QUANTUM_TOKEN_GENERATED,
  QUANTUM_TOKEN_ERROR,
} from "./index";

// Fetch quantum readiness overview data
export const fetchQuantumOverview = (props, dispatch) => {
  //console.log("fetchQuantumOverview called with ID:", props);

  if (props) {
    /*const session = localStorage.getItem("session");
        console.log("Session token from localStorage:", session);
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
        console.log("Headers being sent:", axios.defaults.headers.common);
                
        console.log(`Fetching quantum overview from: ${QUANTUM_API}/quantum-overview/${props}`);

        // Make sure we have a valid auth token
        if (!session) {
            console.error("No authentication token available");
            return dispatch({
                type: QUANTUM_OVERVIEW_FETCHED,
                payload: { error: true, userMessage: "Authentication required" }
            });
        }
        
        // Set the Authorization header
        const config = {
            headers: {
            Authorization: `Bearer ${session}`
            }
        };
        
        console.log("Making authenticated request to quantum API");*/

    axios
      .get(`${QUANTUM_API}/quantum-overview/${props}` /*, config*/)
      //.get(`/quantum/api/quantum-overview/${props}`)
      .then((res) => {
        //console.log("Quantum overview response:", res.data);
        dispatch({
          type: QUANTUM_OVERVIEW_FETCHED,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.error("Error fetching quantum overview:", err);

        dispatch({
          type: QUANTUM_OVERVIEW_FETCHED,
          payload: {
            error: true,
            userMessage: "Could not connect to Quantum API",
          },
        });
      });
  }
};

// Fetch graph data for visualization
export const fetchQuantumGraphData = (props, dispatch) => {
  //console.log("fetchQuantumGraphData called with ID:", props);

  if (props) {
    /*const session = localStorage.getItem("session");
        console.log("Session token from localStorage:", session);
        axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
        console.log("Headers being sent:", axios.defaults.headers.common);

        console.log(`Fetching graph data from: ${QUANTUM_API}/quantum-details/graph/${props}`);
      
        // Make sure we have a valid auth token
        if (!session) {
            console.error("No authentication token available");
            return dispatch({
                type: QUANTUM_GRAPH_DATA_FETCHED,
                payload: { error: true, userMessage: "Authentication required" }
            });
        }
        
        // Set the Authorization header
        const config = {
            headers: {
            Authorization: `Bearer ${session}`
            }
        };
        
        console.log("Making authenticated request to quantum API");*/

    axios
      .get(`${QUANTUM_API}/quantum-details/graph/${props}` /*, config*/)
      //.get(`/quantum/api/quantum-details/graph/${props}`)
      .then((res) => {
        //console.log("Quantum graph data response:", res.data);
        dispatch({
          type: QUANTUM_GRAPH_DATA_FETCHED,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.error("Error fetching quantum graph data:", err);

        dispatch({
          type: QUANTUM_GRAPH_DATA_FETCHED,
          payload: {
            error: true,
            userMessage: "Could not connect to Quantum API",
          },
        });
      });
  }
};

// Fetch detailed quantum readiness data for a specific category
export const fetchQuantumDetails = (
  props,
  dispatch,
  category,
  page = 1,
  limit = 10,
  searchQuery = ""
) => {
  //console.log("fetchQuantumDetails called with:", { props, category, page, limit, searchQuery });

  if (props) {
    /*const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;*/

    // Build URL to match your existing API structure
    let url = `${QUANTUM_API}/quantum-details/${category}/${props}?page=${page}&limit=${limit}`;
    if (searchQuery) {
      url += `&query=${encodeURIComponent(searchQuery)}`;
    }

    //console.log("Fetching quantum details from:", url);

    axios
      .get(url)
      .then((res) => {
        //console.log(`Quantum details response for ${category}:`, res.data);
        dispatch({
          type: QUANTUM_DETAILS_FETCHED,
          payload: {
            category: category,
            data: res.data,
          },
        });
      })
      .catch((err) => {
        console.error(`Error fetching quantum details for ${category}:`, err);
        var message = "Could not connect to Quantum API";
        if (err.response && err.response.data) {
          message =
            err.response.data.userMessage || err.response.data.error || message;
        }

        dispatch({
          type: QUANTUM_DETAILS_FETCHED,
          payload: {
            category: category,
            error: true,
            userMessage: message,
          },
        });
      });
  }
};

// New action for downloading the quantum scanner
export const generateQuantumToken = (orgId, dispatch) => {
  // Set token generation in progress
  dispatch({
    type: QUANTUM_TOKEN_GENERATING,
  });

  // Get user info from localStorage
  const authUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = authUser._id || authUser.userId;

  if (!userId) {
    toastr.error("Token Generation Failed", "User information not available");
    dispatch({
      type: QUANTUM_TOKEN_ERROR,
      payload: { error: "User information not available" },
    });
    return Promise.reject("User information not available");
  }

  //console.log(`Generating token for user ${userId} and org ${orgId}`);

  // Call the API without auth headers
  return axios
    .post(`${QUANTUM_API}/generate-download-token`, {
      userId: userId,
      organisationId: orgId,
    })
    .then((response) => {
      if (response.data && response.data.installToken) {
        const token = response.data.installToken;

        // Store in localStorage
        //localStorage.setItem("quantum_install_token", token);
        localStorage.setItem(`quantum_install_token_${orgId}`, token);

        // Update Redux
        dispatch({
          type: QUANTUM_TOKEN_GENERATED,
          payload: {
            token: token,
            generatedAt: new Date().toISOString(),
            organisationId: orgId, // Store orgId with the token
          },
        });

        // Show success message
        toastr.success(
          "Token Generated",
          "Installation token generated successfully"
        );

        return token;
      } else {
        throw new Error("Invalid response from server");
      }
    })
    .catch((error) => {
      console.error("Token generation error:", error);

      const errorMessage =
        error.response?.data?.message ||
        "Failed to generate installation token";
      toastr.error("Token Generation Failed", errorMessage);

      dispatch({
        type: QUANTUM_TOKEN_ERROR,
        payload: { error: errorMessage },
      });

      return Promise.reject(error);
    });
};

// Download function without auth requirements
export const downloadQuantumScanner = (orgId, dispatch) => {
  // First dispatch action to show download is starting
  dispatch({
    type: QUANTUM_DOWNLOAD_START,
  });

  // Get the token from localStorage
  //let installToken = localStorage.getItem("quantum_install_token");
  let installToken = localStorage.getItem(`quantum_install_token_${orgId}`);

  // If no token exists, generate one first
  const generateAndDownload = async () => {
    try {
      // If token doesn't exist, generate a new one
      if (!installToken) {
        // Generate token first
        //const token = await generateQuantumToken(orgId, dispatch);
        //installToken = token;
        installToken = await generateQuantumToken(orgId, dispatch);
        //}

        // Token is already stored in localStorage and Redux by generateQuantumToken
      } else {
        // If we're using an existing token, make sure Redux state is updated too
        dispatch({
          type: QUANTUM_TOKEN_GENERATED,
          payload: {
            token: installToken,
            generatedAt: new Date().toISOString(),
            organisationId: orgId,
          },
        });
      }
      // Now initiate the download with the token
      const downloadUrl = `${QUANTUM_API}/downloads/pqr-tool.exe?token=${installToken}`;

      // Create a hidden iframe to handle the download
      /*const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe.src = downloadUrl;*/

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "quantum-scanner.zip"); // Specify filename
      link.setAttribute("target", "_blank"); // Open in new tab/window
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the iframe after a delay
      setTimeout(() => {
        //document.body.removeChild(iframe);
        document.body.removeChild(link);
        dispatch({
          type: QUANTUM_DOWNLOAD_SUCCESS,
        });
      }, 2000);

      // Show success notification
      toastr.success("Download Started", "Your download should begin shortly");
    } catch (error) {
      console.error("Download error:", error);
      toastr.error(
        "Download Failed",
        error.response?.data || "Unable to download the quantum scanner"
      );

      dispatch({
        type: QUANTUM_DOWNLOAD_ERROR,
        payload: { error: error.message },
      });
    }
  };

  // Start the process
  generateAndDownload();
};
